import { render, staticRenderFns } from "./VerticalUserList.vue?vue&type=template&id=069201d4"
import script from "./VerticalUserList.vue?vue&type=script&lang=ts"
export * from "./VerticalUserList.vue?vue&type=script&lang=ts"
import style0 from "./VerticalUserList.vue?vue&type=style&index=0&id=069201d4&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports